import { render, staticRenderFns } from "./loginFoot.vue?vue&type=template&id=09bc35e4&scoped=true"
import script from "./loginFoot.vue?vue&type=script&lang=js"
export * from "./loginFoot.vue?vue&type=script&lang=js"
import style0 from "./loginFoot.vue?vue&type=style&index=0&id=09bc35e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc35e4",
  null
  
)

export default component.exports